import { Box, Grid, Skeleton, Divider, Paper, Container } from "@mui/material";

export const AeskinsSkeletons = () => (
  <Box>
    <Grid container>
      <Grid item xs={12} md={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="flex-start"
          sx={{
            width: { xs: "100%", md: "100%" },
            mb: 4,
          }}
        >
          <Grid item xs={12} md={3.2}>
            <Skeleton variant="text" width={220} height={40} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={180} height={30} />
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-start" },
              gap: 1,
              mt: { xs: 2, md: 0 },
            }}
          >
            <Skeleton variant="rectangular" width={120} height={40} sx={{ mr: 1 }} />
            <Skeleton variant="rectangular" width={120} height={40} sx={{ mr: 1 }} />
            <Skeleton variant="rectangular" width={120} height={40} />
          </Grid>
        </Grid>
        <Divider
          sx={{
            width: "100%",
            mb: "11.5px",
            borderColor: "#707070",
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Skeleton variant="text" width={200} height={35} sx={{ mb: 3 }} />
      </Grid>

      <Grid container gap={3.5}>
        <Grid item xs={12} md={3}>
          <Box>
            <Paper sx={{ borderRadius: 2, mt: { xs: 2, md: 0 }, mb: 2 }}>
              <Container sx={{ py: 2 }}>
                <Skeleton variant="rectangular" width="100%" height={120} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={40} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={40} />
              </Container>
            </Paper>
            <Paper sx={{ borderRadius: 2, mt: { xs: 2, md: 2 } }}>
              <Container sx={{ py: 2 }}>
                <Skeleton variant="rectangular" width="100%" height={120} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={40} sx={{ mb: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={40} />
              </Container>
            </Paper>
          </Box>
        </Grid>
        <Grid item xs={6} md={7}>
          <Skeleton variant="rectangular" width="100%" height={350} />
        </Grid>
      </Grid>
    </Grid>
  </Box>
);
